var map = {
	"./about.png": 7179,
	"./arrow-down.png": 8866,
	"./arrow_curve.gif": 7524,
	"./capture.png": 5098,
	"./emergency.png": 399,
	"./esri-streets.png": 4082,
	"./esri-topo.png": 380,
	"./feedback-footer.png": 7247,
	"./feedback.png": 3395,
	"./globe-icon.png": 7337,
	"./help.png": 9131,
	"./information.png": 6790,
	"./legend-footer.png": 8917,
	"./legend.png": 5845,
	"./lio-topo.png": 5915,
	"./menu.png": 3455,
	"./osm-topo.jpg": 6662,
	"./other.png": 9758,
	"./pdf.png": 3594,
	"./print.png": 3789,
	"./school.png": 2894,
	"./screenshot.png": 1462,
	"./search.png": 5106,
	"./tab-close.png": 5074,
	"./tab-open.png": 8520,
	"./target.png": 6169,
	"./terms-footer.png": 4209,
	"./terms.png": 5065,
	"./themes.png": 8804,
	"./tools.png": 8453,
	"./userFarms.png": 3623,
	"./waste.png": 1798,
	"components/MapSwitcher/images/about.png": 7179,
	"components/MapSwitcher/images/arrow-down.png": 8866,
	"components/MapSwitcher/images/arrow_curve.gif": 7524,
	"components/MapSwitcher/images/capture.png": 5098,
	"components/MapSwitcher/images/emergency.png": 399,
	"components/MapSwitcher/images/esri-streets.png": 4082,
	"components/MapSwitcher/images/esri-topo.png": 380,
	"components/MapSwitcher/images/feedback-footer.png": 7247,
	"components/MapSwitcher/images/feedback.png": 3395,
	"components/MapSwitcher/images/globe-icon.png": 7337,
	"components/MapSwitcher/images/help.png": 9131,
	"components/MapSwitcher/images/information.png": 6790,
	"components/MapSwitcher/images/legend-footer.png": 8917,
	"components/MapSwitcher/images/legend.png": 5845,
	"components/MapSwitcher/images/lio-topo.png": 5915,
	"components/MapSwitcher/images/menu.png": 3455,
	"components/MapSwitcher/images/osm-topo.jpg": 6662,
	"components/MapSwitcher/images/other.png": 9758,
	"components/MapSwitcher/images/pdf.png": 3594,
	"components/MapSwitcher/images/print.png": 3789,
	"components/MapSwitcher/images/school.png": 2894,
	"components/MapSwitcher/images/screenshot.png": 1462,
	"components/MapSwitcher/images/search.png": 5106,
	"components/MapSwitcher/images/tab-close.png": 5074,
	"components/MapSwitcher/images/tab-open.png": 8520,
	"components/MapSwitcher/images/target.png": 6169,
	"components/MapSwitcher/images/terms-footer.png": 4209,
	"components/MapSwitcher/images/terms.png": 5065,
	"components/MapSwitcher/images/themes.png": 8804,
	"components/MapSwitcher/images/tools.png": 8453,
	"components/MapSwitcher/images/userFarms.png": 3623,
	"components/MapSwitcher/images/waste.png": 1798
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6012;